import { render, staticRenderFns } from "./CommentFooter.vue?vue&type=template&id=238f00d8"
import script from "./CommentFooter.vue?vue&type=script&lang=js"
export * from "./CommentFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports